import React, { useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css'
import Splashscreen from './pages/Splashscreen'
import Pages from './pages/Pages';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './styles/Carousel.css'

AOS.init();

function App() {
  const [showSplash, setShowSplash] = useState(true);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setShowSplash(false);
    }, 7500);

    return () => {
      clearTimeout(timeout);
    };
  }, []);

  return (
    <>
      {/* <Splashscreen/>  */}
      { showSplash ?  <Splashscreen/> : <Pages />}
    </>
  );
}

export default App;
